import CookiesKeys, { cookieStorage } from "../../services/cookies";

export const getToken = (): string | null => {
  return localStorage.getItem(CookiesKeys.TokenKey);
};

export const login = (token: string) => {
  localStorage.setItem(CookiesKeys.TokenKey, token);
};

export const logout = () => {
  localStorage.removeItem(CookiesKeys.TokenKey);
};

export const getTokenCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.TokenKey);
};

export const loginCookie = (token: string) => {
  cookieStorage.setItem(CookiesKeys.TokenKey, token);
};

export const removeloginCookie = () => {
  cookieStorage.removeItem(CookiesKeys.TokenKey);
};
